import validation from '../../../../mixins/validation'
import { email, required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'HomeEsputnik',
  props: {},
  emits: [],
  components: {},
  setup() {},
  mixins: [validation],
  data() {
    return {
      payload: {
        email: '',
      },
      loading: false,
      sussessMessage: '',
      validationErrors: {},
    }
  },
  validations() {
    return {
      payload: {
        email: {
          required,
          email,
        },
      },
    }
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {
    emailErrors() {
      return this.computeErrors('payload', 'email', {
        required: 'validationRequired',
        email: 'pleaseEnterAValidEmailAddress',
      })
    },
  },
  methods: {
    ...mapActions({
      esputnikSubscribe: 'esputnik/ESPUTNIK_SUBSCRIBE',
    }),
    async subscribeToEsputnik() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      const localPayload = { ...this.payload }
      localPayload['locale'] = localStorage.getItem('app_locale')
      try {
        this.loading = true
        const response = await this.esputnikSubscribe(localPayload)
        this.sussessMessage = response.data.message
      } catch (error) {
        console.error('ESputnik error: ', error)
      } finally {
        this.loading = false
      }
    },
  },
}
